import React from 'react';
import { images } from '../../assets/images';
import './Footer.css';
import { Link, useNavigate } from 'react-router-dom';



const legalLinks = [
  { label: 'Cookie notice', href: 'https://www.unilevernotices.com/cookie-notices/pakistan-english.html' },
  { label: 'Privacy notice', href: 'https://www.unilevernotices.com/privacy-notices/pakistan-english.html' },
];

const socialLinks = [
  { icon: images.facebookIcon, label: 'Facebook', href: 'https://www.facebook.com/share/1aJb9mAkqs/?mibextid=wwXIfr' },
  { icon: images.instagramIcon, label: 'Instagram', href: 'https://www.instagram.com/knorr_pk/#' },
  { icon: images.youtubeIcon, label: 'YouTube', href: 'https://www.youtube.com/@KnorrPakistanOfficial' },
  { icon: images.tiktokIcon, label: 'TikTok', href: 'https://www.tiktok.com/@knorr.pakistan' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-background">
        <img src={images.footerBg} alt="" className="footer-bg-image" />
      </div>
      <div className="footer-content">
        {/* Logo Section */}
        <div className="footer-logo-section">
          <Link to="/" className="footer-logo-link">
            <img 
              src={images.knorrLogo} 
              alt="Knorr Logo" 
              className="footer-logo"
            />
          </Link>
        </div>

        {/* Links Grid */}
        <div className="footer-links-grid">
          <div className="footer-column">
            <h4 className="footer-column-title">Legal</h4>
            <ul className="footer-links-list">
              {legalLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="footer-link" target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </a>
                </li>
              ))}
              <li key={3}>  
                <Link className="footer-link" to="/terms"  target="_blank"  rel="noopener noreferrer">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Consumer Service Column */}
          <div className="footer-column">
            <h4 className="footer-column-title">Consumer service</h4>
            <ul className="footer-links-list">
              <li>
                <Link to="https://api.whatsapp.com/send/?phone=923331121357&text&type=phone_number&app_absent=0" className="footer-link contact-link" target="_blank" rel="noopener noreferrer">
                  Contact us
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links Column */}
          <div className="footer-column">
            <h4 className="footer-column-title">Find us on</h4>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.href} 
                  className="social-link"
                  aria-label={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img 
                    src={social.icon} 
                    alt={social.label} 
                    className="social-icon"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
